import React, { useContext } from 'react';
import { FILTER } from '../../../../../../config/filters';
import { AppContext } from '../../../../../context/listingsContext';
import { decideOnSellerToggleFilters } from '../../../../seller_toggle_filter';
import { getFilterById } from '../../../../util';
import { BI_SOURCES } from '../../../../../../utils/constants';
import BusinessProToggle from './business_pro_toggle';
import ProToggle from './pro_toggle';
import SellerOnlineToggle from './seller_online_toggle';
import LocalSellerToggle from './local_seller_toggle';
import SubscriptionToggle from './subscription_toggle';
import LanguageSellerToggle from './language_seller_toggle';

const ToggleFilters = ({ filters }) => {
    const { isBusiness, assumedLanguage } = useContext(AppContext);

    const sellerToggleFilter = decideOnSellerToggleFilters(filters, { assumedLanguage });
    const subscriptionFilter = getFilterById(filters, FILTER.SUBSCRIPTION.ID);

    const SellerToggleFilter = sellerToggleFilter &&
        sellerToggleFilter.id === FILTER.SELLER_LOCATION.ID ? LocalSellerToggle : LanguageSellerToggle;

    return (
        <div className="togglers-wrapper">
            {
                isBusiness
                    ? (
                        <BusinessProToggle {...getFilterById(filters, FILTER.PRO.ID)} source={BI_SOURCES.TOGGLE_FILTERS}/>
                    )
                    : <>
                        <ProToggle tooltip filter={getFilterById(filters, FILTER.PRO.ID)} source={BI_SOURCES.TOGGLE_FILTERS}/>
                        {
                            subscriptionFilter ?
                                <SubscriptionToggle tooltip filter={subscriptionFilter} source={BI_SOURCES.TOGGLE_FILTERS}/>
                                :
                                SellerToggleFilter && <SellerToggleFilter tooltip filter={sellerToggleFilter} source={BI_SOURCES.TOGGLE_FILTERS}/>
                        }

                        <SellerOnlineToggle tooltip filter={getFilterById(filters, FILTER.IS_SELLER_ONLINE.ID)} source={BI_SOURCES.TOGGLE_FILTERS}/>
                    </>
            }
        </div>

    );};

export default ToggleFilters;
